import { defineRecipe } from '@chakra-ui/react';

import {
  inputDefaultVariant,
  inputFilledVariant,
  inputLoginVariant,
  inputTransparentVariant,
  inputUnstyledVariant,
} from '../variants/input';

export const inputGroupRecipe = defineRecipe({
  className: 'chakra-group',
  base: {
    width: '100%',
    border: '2px solid',
    borderColor: 'neutral.300',
    paddingLeft: 16,
    _focusWithin: {
      borderColor: 'skyBlue',
    },
    _hover: {
      borderColor: 'skyBlue',
    },
  },
  variants: {
    variant: {
      login: {
        bg: 'neutral.white',
        borderRadius: 'md',
        padding: '4px',
      },
    },
    size: {
      sm: {
        height: '48px',
      },
      md: {
        height: '56px',
      },
    },
  },
  defaultVariants: {
    variant: 'login',
    size: 'sm',
  },
});

export const inputRecipe = defineRecipe({
  base: {
    width: '100%',
    padding: 2,
    rounded: 'none',
    _readOnly: {
      cursor: 'default',
    },
  },
  variants: {
    variant: {
      default: inputDefaultVariant,
      login: inputLoginVariant,
      filled: inputFilledVariant,
      transparent: inputTransparentVariant,
      unstyled: inputUnstyledVariant,
    },
    size: {
      sm: {
        height: '48px',
      },
      md: {
        height: '56px',
      },
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'sm',
  },
});
